import { animated, config, useSprings, useTransition } from '@react-spring/web';
import { Dimensions } from './hooks/useWindowDimensions';
import PieceSvg from './svg/PieceSvg';

export const getSpinnerSize = (windowDim: Dimensions, max: number) => Math.min(max, Math.min(windowDim.width, windowDim.height) / 2);

const Spinner = ({ size, color, enabled }: { size: number; color: string; enabled: boolean }) => {
	const [springs] = useSprings(
		4,
		(i) => {
			const d = (enabled ? 0.185 : 0.75) * size;
			const p = [i % 4, (i + 1) % 4, (i + 2) % 4, (i + 3) % 4, (i + 4) % 4];
			const px = [d, d, -d, -d];
			const py = [-d, d, d, -d];
			const r1 = [45, 135, 225, 315, 405];
			const r2 = [135, 45, -45, -135, -225];
			return {
				from: { x: px[p[0]], y: py[p[0]], rotateZ: i % 2 === 0 ? r1[0] : r2[0] },
				to: [1, 2, 3, 4].map((j) => ({ x: px[p[j]], y: py[p[j]], rotateZ: i % 2 === 0 ? r1[j] : r2[j] })),
				loop: true,
				config: enabled ? config.stiff : config.molasses,
			};
		},
		[size, enabled]
	);

	const transition = useTransition(enabled, {
		from: { opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
	});

	return transition(
		(transitionStyle, item) =>
			item && (
				<animated.div style={{ width: size / 2, height: size / 2, ...transitionStyle }}>
					{springs.map((springStyle, i) => (
						<animated.div
							key={'p' + i}
							className="absolute drop-shadow"
							style={{ ...springStyle, opacity: 0.25 * (i + 1), width: size / 2, height: size / 2 }}>
							<PieceSvg width={size / 2} height={size / 2} fill={color} />
						</animated.div>
					))}
				</animated.div>
			)
	);
};

export default Spinner;
